export const EditorAssetLayers = {
  BOX: 1,
}
